import React from "react"

import { useRouter } from "next/router"

import { Col, Form } from "react-bootstrap"

function OrderByField() {
    const router = useRouter()

    const { ordering } = router.query

    return (
        <>
            {/* Order Field */}
            <Col sm={6}>
                <Form.Label htmlFor="orderBy">
                    <span className="text-semi-bold">Sort by</span>
                </Form.Label>
                <Form.Select
                    aria-label="Default select example"
                    value={ordering ? ordering : "-update_date"}
                    onChange={(e) => {
                        router.query.ordering = e.target.value
                        router.push(router)
                    }}
                >
                    <option value="-update_date">Most recently updated</option>
                    <option value="-price">Price (High to low)</option>
                    <option value="price">Price (Low to high)</option>
                    <option value="-bedrooms">Bedrooms (High to low)</option>
                    <option value="bedrooms">Bedrooms (Low to High)</option>
                </Form.Select>
            </Col>
            {/* Order Field End */}
        </>
    )
}

export default OrderByField
